import { FC } from 'react'
import { Tag } from 'components/Global/Tag'

type ProductCardTagsProps = {
  isPreorder?: boolean
  isBackorder?: boolean
  discount?: string
}

export const ProductCardTags: FC<ProductCardTagsProps> = (props) => {
  const { isPreorder, isBackorder, discount } = props

  if (!isPreorder && !isBackorder && !discount) return null

  return (
    <div
      className={`pointer-events-none absolute left-0 top-0 z-[5] flex w-full items-center gap-4 px-10 py-10 md:px-20 md:py-28 ${
        discount ? 'justify-between' : 'justify-between'
      }`}
    >
      <div className="flex items-start gap-4">
        {isPreorder ? (
          <Tag className="bg-yellow md:!px-8 md:!text-10">Preorder</Tag>
        ) : isBackorder ? (
          <Tag className="bg-yellow md:!px-8 md:!text-10">Backorder</Tag>
        ) : null}
      </div>

      {discount ? (
        <Tag className="bg-yellow md:!px-8 md:!text-10">
          {discount} off<span className="hidden md:inline"> ends soon</span>
        </Tag>
      ) : null}
    </div>
  )
}
